var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('span',[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("mdi-google-maps")]),_vm._v(" "+_vm._s(_vm.description)+" "),(_vm.showLatLong)?_c('LatLong',{attrs:{"location":_vm.latLong}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }